<dx-popup [title]="'Authorization Required' | translate"
          [visible]="isVisible"
          [shading]="true"
          [resizeEnabled]="false"
          [showCloseButton]="false"
          [closeOnOutsideClick]="false"
          [width]="350"
          [height]="250">
  <form (submit)="onFormSubmit($event)">
    <dx-form id="form"
             [formData]="authorization"
             [labelLocation]="labelLocation"
             [labelMode]="labelMode"
             [showColonAfterLabel]="false">
      <dxi-item [dataField]="'username'">
        <dxo-label [text]="'Username' | translate"></dxo-label>
        <dxi-validation-rule [type]="'required'" [message]="'Please enter user name' | translate"></dxi-validation-rule>
      </dxi-item>
      <dxi-item [dataField]="'password'" [editorOptions]="{ mode: 'password' }">
        <dxo-label [text]="'Password' | translate"></dxo-label>
        <dxi-validation-rule [type]="'required'" [message]="'Please enter password' | translate"></dxi-validation-rule>
      </dxi-item>
      <dxi-item [itemType]="'button'"
                [horizontalAlignment]="'left'"
                [buttonOptions]="submitButtonOptions">
      </dxi-item>
    </dx-form>
  </form>
</dx-popup>
